<app-header *ngIf="isLayout"></app-header>
<router-outlet></router-outlet>
<app-footer
  *ngIf="isLayout"
  [paddingBottom]="showLatestSurveyHref ? '55px' : undefined"
></app-footer>
<a
  href="https://wa.me/905333792509?text={{ msgText }}"
  target="_blank"
  class="wp-button"
  [ngStyle]="{
    bottom: showLatestSurveyHref ? '70px' : undefined
  }"
>
  <img src="/assets/images/whatsapp.svg" alt="Whatsapp" />
</a>

<!-- Continue Survey Fixed Button -->
<div
  class="continue-survey-button-container"
  *ngIf="showLatestSurveyHref && latestSurveyHref"
>
  <a
    class="continue-survey-button"
    href="javascript:void(0)"
    (click)="goToLatestSurvey()"
  >
    <svg
      class="send-icon"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 21L23 12L2 3V10L17 12L2 14V21Z" fill="currentColor" />
    </svg>
    <span>Ankete devam et</span>
  </a>
</div>
